export const ACTIVE = 0;
export const WON = 1;
export const LOST = 2;
export const REFUND = 3;



// WEBPACK FOOTER //
// ./js/constants/StakeStatus.js